export default "__VITE_ASSET__uXwXnxYB__"